import {UI} from "../../../../../../stem-core/src/ui/UIBase";
import {StyleSheet} from "../../../../../../stem-core/src/ui/Style";
import {styleRule} from "../../../../../../stem-core/src/decorators/Style";

import {MerchantLogo} from "../../../../../common/MerchantLogo";
import {iFrameState} from "../../../../../services/IFrameState";
import {Messages} from "../../../../../Messages";
import {registerStyle} from "../../../../../../stem-core/src/ui/style/Theme";
import {Button} from "../../../../../../stem-core/src/ui/button/Button";
import {isSmallScreen} from "../../../../../UtilsLib";
import {iFrameConnection} from "../../../../../services/IFrameConnection";
import {IFrameMessages} from "../../../../../../blink-sdk/messaging/IFrameMessages";
import {Dispatcher} from "../../../../../../stem-core/src/base/Dispatcher";
import {merchantStyleRule} from "../../../../Security";
import {collapseIframe} from "../../../../../widget/misc/WidgetUtils";
import {iFrameMerchantService} from "../../../../../services/IframeMerchantService";


class AdBlockerDisableStyle extends StyleSheet {
    @styleRule
    component = {
        textAlign: "center",
    };

    @styleRule
    title = {
        fontSize: () => isSmallScreen() ? 18 : 20,
        fontWeight: this.themeProps.MERCHANT_FONT_WEIGHT_BOLD,
        margin: () => isSmallScreen() ? "6px 0" : "12px 0",
    };

    @styleRule
    description = {
        fontSize: () => isSmallScreen() ? 15 : 18,
        opacity: 0.7,
        marginBottom: () => isSmallScreen() ? 10 : 18,
    };

    @merchantStyleRule
    button = {
        fontSize: this.themeProps.MERCHANT_FONT_SIZE_LARGE,
        fontWeight: this.themeProps.MERCHANT_FONT_WEIGHT_BOLD,
        ...this.themeProps.AD_BLOCK_BUTTON,
        ...iFrameState.actionButtonStyle,
    }
}

@registerStyle(AdBlockerDisableStyle)
export class AdBlockerDisable extends UI.Element {
    extraNodeAttributes(attr) {
        super.extraNodeAttributes(attr);
        attr.addClass(this.styleSheet.component);
    }

    render() {
        const {styleSheet} = this;
        const merchant = iFrameMerchantService.getMerchant();

        return [
            <MerchantLogo />,
            <div className={styleSheet.title}>{Messages.adBlockerDisableTitle(merchant.getName())}</div>,
            <div className={styleSheet.description}>{Messages.adBlockerDisableDescription}</div>,
            <Button className={styleSheet.button} onClick={() => {
                Dispatcher.Global.addListenerOnce("collapseIframe", () => {
                    // Not specifying a URL here determines the merchant's current page to refresh
                    iFrameConnection.sendToSDK(IFrameMessages.REDIRECT_TO_URL);
                });
                collapseIframe();
            }}>
                {Messages.adBlockerDisableButton}
            </Button>,
        ];
    }
}
